import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  CalendarEvent,
  CalendarEventScheduleInterval,
  CalendarEventUnavailabilityReasonEnum,
} from '../../models/calendar-event.model';
import { Observable } from 'rxjs';
import { DateTime, Duration } from 'luxon';
import { environment } from '../../../environments/environment';
import { DateUtils } from 'ats-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class CalendarEventService {
  constructor(private http: HttpClient) {}

  getTimezoneForDateTimePipe(timezoneOffsetInHours: number): string {
    let timezoneForPipe = 'UTC';
    if (timezoneOffsetInHours != 0) {
      const duration = Duration.fromObject({ hours: timezoneOffsetInHours });
      timezoneForPipe += `${timezoneOffsetInHours > 0 ? '+' : ''}${duration.toFormat('hh:mm')}`;
    }
    return timezoneForPipe;
  }

  getTimezoneName(timezoneOffsetInHours: number): string {
    switch (timezoneOffsetInHours) {
      case -3:
        return 'l-time-zone-brasilia';
      default:
        return this.getTimezoneSmallName(timezoneOffsetInHours);
    }
  }

  getTimezoneSmallName(timezoneOffsetInHours: number): string {
    let timezone = 'GMT';
    if (timezoneOffsetInHours != 0) {
      const duration = Duration.fromObject({ hours: timezoneOffsetInHours });
      timezone += `${timezoneOffsetInHours > 0 ? '+' : ''}${duration.toFormat('hh:mm')}`;
    }
    return timezone;
  }

  scheduleEvent(eventId: string, interval: CalendarEventScheduleInterval): Observable<unknown> {
    return this.http.post<CalendarEvent>(
      `${environment.applicantApiEndpoint}/calendar-event/schedule-event`,
      {
        calendarEventId: eventId,
        ...interval,
      },
    );
  }

  setUnavailability(
    calendarEventId: string,
    unavailabilityReason: CalendarEventUnavailabilityReasonEnum,
  ): Observable<unknown> {
    return this.http.post<CalendarEvent>(
      `${environment.applicantApiEndpoint}/calendar-event/set-unavailability`,
      { calendarEventId, unavailabilityReason },
    );
  }

  isIntervalInThePast(interval: CalendarEventScheduleInterval): boolean {
    const beginDateTime = DateUtils.dateTimeFromStringOrJs(interval.begin);
    const isInThePast = beginDateTime < DateTime.local();
    return isInThePast;
  }
}
